import { FABRIC_HEADERS } from '@/utilities/constants/metadata';
import {
  getLoginToken,
  getSession,
  initializeUM,
} from '@/unified-modules/account/account-library';

export type FabricAuthTokens = {
  authToken: string;
  loginToken: string;
};

/**
 * Resolves Fabric header auth from Account UM at request time (not cookie parse).
 * Ensures UM is initialized, then loads session + login token in parallel.
 */
export const getFabricAuthTokens = async (
  logLabel: string,
): Promise<FabricAuthTokens> => {
  await initializeUM();

  const [session, loginToken] = await Promise.all([
    getSession(),
    getLoginToken(),
  ]);

  const authToken = session?.token;

  if (!authToken || !loginToken) {
    throw new Error(`[GW][${logLabel}] No auth headers`);
  }

  return { authToken, loginToken };
};

/** Auth JWT only (FGP body-token endpoints — no login header). */
export const getFabricAuthToken = async (logLabel: string): Promise<string> => {
  await initializeUM();
  const session = await getSession();
  const authToken = session?.token;

  if (!authToken) {
    throw new Error(`[GW][${logLabel}] No auth headers`);
  }

  return authToken;
};

export const buildFabricAuthHeaders = (
  tokens: FabricAuthTokens,
): Record<string, string> => ({
  [FABRIC_HEADERS.X_AUTH]: tokens.authToken,
  [FABRIC_HEADERS.X_LOGIN]: tokens.loginToken,
});
